<script>

  import util from './SgsUtils';
  import MaskedField from 'src/components/utils/MaskedField.vue';

  import { CNPJ } from 'cpf_cnpj';

  export default{
    props: [
      "attr", "fieldValue", "rules", "label",
      "showHint", "hintValue", "moduleType"
    ],
    computed: {
      updateFieldValue: {
        get: function() {
          let fieldFormatted = this.fieldValue;

          if (this.fieldValue) {
            fieldFormatted = fieldFormatted.replace(/\D/g,"");

            fieldFormatted = fieldFormatted.replace(/^(\d{2})(\d)/,"$1.$2");
            fieldFormatted = fieldFormatted.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3");
            fieldFormatted = fieldFormatted.replace(/\.(\d{3})(\d)/,".$1/$2");
            fieldFormatted = fieldFormatted.replace(/(\d{4})(\d)/,"$1-$2");

            return fieldFormatted;
          }

          return this.fieldValue;
        },
        set: function(newValue) {
          this.$emit('updateFieldValue', this.attr.columnName, newValue);
        }
      }
    },
    methods: {
      callBusinessRule: function(BusinessRuleId) {
        this.$emit('callBusinessRule', BusinessRuleId);
      }
    },
    components: {
      MaskedField
    },
    created() {
      util.resolveRules(this.attr, this.rules);
      if(this.rules) {
        this.rules[this.attr.columnName].push({
          validator: (rules, value, callback) => {
            if(value && !CNPJ.isValid(value)){
              callback(new Error(this.$t("cnpj") + "  " + this.$t("invalid") + "!"));
            }
            callback();
          },
          trigger: 'blur'
        });
      }
    }
  }
</script>
<template>
  <div>
    <el-popover
      ref="popover"
      v-show="showHint"
      placement="top-start"
      width="200"
      trigger="hover"
      :content="hintValue">
    </el-popover>

    <el-form-item label="temp" :prop="attr.columnName" v-if="moduleType === 'form'">

      <span slot="label">
        {{label}} <i v-if="showHint && moduleType === 'form'" class="glyphicon glyphicon-question-sign" v-popover:popover />
      </span>

      <MaskedField
        :mask="'##.###.###/####-##'"
        v-model="updateFieldValue"
        :placeholder="'99.999.999/9999-99'"
        :attr="attr"
        @callBusinessRule="callBusinessRule"
      />
    </el-form-item>
    <div v-if="moduleType === 'show'">
      <label>{{label}}</label>
      <p>
        <span>
          {{updateFieldValue}}
        </span>
      </p>
    </div>
    <span v-if="moduleType === 'list'">
      {{updateFieldValue}}
    </span>
  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderInputCnpj.vue?a8911290